export default function FormDivider() {
  return (
    <div className="pt-12 pb-6">
      <div className="w-full h-[1px] bg-grey006" />
    </div>
  );
}
